export enum PlaceSubType {
  airport = 'airport',
  attractions = 'attractions',
  hotel = 'hotel',
  distrcict = 'distrcict',
  city = 'city',
  trainStation = 'trainStation',
  transitStation = 'transitStation',
  subwayStation = 'subwayStation',
  busStation = 'busStation',
  organization = 'organization',
}
